import { Group, Identifiable } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedResource, Linker } from "../linkers/types";

function editPlanzoneResourceGroup(httpClient: HttpClient, linker: Linker) {
  return ({ uuid }: Identifiable<Group>, nextGroup: Group) =>
    httpClient
      .sendHttpRequest<LinkedResource<Identifiable<Group>>>({
        endpoint: `/planzoneResourceGroups/${uuid}`,
        method: HttpMethods.PATCH,
        data: { name: nextGroup.name, description: nextGroup.description },
      })
      .then(linker.linkPlanzoneResourceGroup);
}

function editProjectResourceGroup(httpClient: HttpClient, linker: Linker) {
  return ({ uuid }: Identifiable<Group>, nextGroup: Group) =>
    httpClient
      .sendHttpRequest<LinkedResource<Identifiable<Group>>>({
        endpoint: `/projectResourceGroups/${uuid}`,
        method: HttpMethods.PATCH,
        data: { name: nextGroup.name, description: nextGroup.description },
      })
      .then(linker.linkProjectResourceGroup);
}

function editResourceGroup(httpClient: HttpClient, linker: Linker) {
  return (group: Identifiable<Group>, nextGroup: Group) =>
    (group.resourceType === "project"
      ? editProjectResourceGroup(httpClient, linker)(group, nextGroup)
      : editPlanzoneResourceGroup(httpClient, linker)(group, nextGroup)
    ).then((editedGroup) => ({
      ...editedGroup,
      resourceType: group.resourceType,
    }));
}

export { editResourceGroup };
